import { Validator } from 'vee-validate'
import AcceptBackDate from './acceptBackDate'
import AcceptStartDate from './acceptStartDate'
import AcceptTodayDate from './acceptTodayDate'
import OptCvr from './optCvr'

export default function install() {
  Validator.extend('accept_back_date', AcceptBackDate)
  Validator.extend('accept_start_date', AcceptStartDate)
  Validator.extend('accept_today_date', AcceptTodayDate)
  Validator.extend('pkg_opt_cvr', OptCvr)
}
